import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Developers from './pages/Developers';
import DeveloperProfile from './pages/DeveloperProfile';
import Teams from './pages/Teams';
import Login from './pages/Login';
import Signup from './pages/Signup';
import PostJob from './pages/PostJob';
import Jobs from './pages/Jobs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import DeveloperLogin from './pages/developer/DeveloperLogin';
import DeveloperDashboard from './pages/developer/DeveloperDashboard';
export function AppRouter() {
  return <Routes data-id="element-3">
      <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
      <Route path="/developers" element={<Developers data-id="element-7" />} data-id="element-6" />
      <Route path="/developers/:id" element={<DeveloperProfile data-id="element-9" />} data-id="element-8" />
      <Route path="/teams" element={<Teams data-id="element-11" />} data-id="element-10" />
      <Route path="/login" element={<Login data-id="element-13" />} data-id="element-12" />
      <Route path="/signup" element={<Signup data-id="element-15" />} data-id="element-14" />
      <Route path="/post-job" element={<PostJob data-id="element-17" />} data-id="element-16" />
      <Route path="/jobs" element={<Jobs data-id="element-19" />} data-id="element-18" />
      <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-21" />} data-id="element-20" />
      <Route path="/terms-of-service" element={<TermsOfService data-id="element-23" />} data-id="element-22" />
      <Route path="/admin/login" element={<AdminLogin data-id="element-25" />} data-id="element-24" />
      <Route path="/admin/dashboard" element={<AdminDashboard data-id="element-27" />} data-id="element-26" />
      <Route path="/developer/login" element={<DeveloperLogin data-id="element-29" />} data-id="element-28" />
      <Route path="/developer/dashboard" element={<DeveloperDashboard data-id="element-31" />} data-id="element-30" />
    </Routes>;
}